import { getTournamentMatchIds } from "model/Tournament/Tournament";
import { RootState } from "app/store";
import { nonUndefined, onlyUnique } from "Utility";
import { selectStagesByName } from "./Tour";
import { selectAllTournaments, selectTournaments } from "./Tournament";
import { tournamentUsesTrack } from "model/Tournament/TournamentTrack";

export const selectTrack = (state: RootState, id: string | undefined) => {
  if (!id) {
    return undefined;
  }

  return state.track.data[id];
};

export const selectTrackName = (state: RootState, id: string | undefined) => {
  if (!id) {
    return undefined;
  }

  return selectTrack(state, id)?.name;
};

export const selectTracks = (state: RootState, ids: string[]) => {
  return nonUndefined(ids.map((id) => selectTrack(state, id)));
};

export const selectUniqueTrackIds = (
  state: RootState,
  year?: string,
  stageName?: string,
  tournamentFilters?: string[]
) => {
  const stages = selectStagesByName(state, year, stageName);
  const tournamentIds = stages.flatMap((s) => s.tournamentIds);
  const tournaments = selectTournaments(state, tournamentIds);
  const trackIds = tournaments
    .filter((t) => tournamentFilters?.includes(t.filterName) ?? true)
    .flatMap((t) => t.tracks.map((track) => track.id));

  return trackIds.filter(onlyUnique);
};

export const selectTournamentIdsFromTrackId = (
  state: RootState,
  trackId: string
) => {
  return selectAllTournaments(state)
    .filter((t) => tournamentUsesTrack(t.tracks, trackId))
    .flatMap((t) => t.id);
};

export const selectTournamentIdsForTrackFilters = (
  state: RootState,
  trackId: string,
  tournamentFilters?: string[]
) => {
  const tournaments = selectAllTournaments(state).filter((t) =>
    tournamentUsesTrack(t.tracks, trackId)
  );

  if (!!tournamentFilters) {
    return tournaments
      .filter((t) => tournamentFilters.includes(t.filterName))
      .map((t) => t.id);
  }

  return tournaments.map((t) => t.id);
};

export const selectTrackFeatureDetails = (
  state: RootState,
  trackId: string
) => {
  const tournamentIds =
    selectTournamentIdsForTrackFilters(state, trackId) ?? [];
  const tournaments = selectTournaments(state, tournamentIds);
  const matchIds = tournaments.flatMap((t) => getTournamentMatchIds(t));

  var firstFeaturedName: string | undefined;
  var firstFeaturedTrigram: string | undefined;
  var firstFeaturedStartTimeMs: number | undefined;
  var lastFeaturedName: string | undefined;
  var lastFeaturedTrigram: string | undefined;
  var lastFeaturedEndTimeMs: number | undefined;
  tournaments.forEach((t) => {
    if (
      firstFeaturedStartTimeMs === undefined ||
      t.startTimeMs < firstFeaturedStartTimeMs
    ) {
      firstFeaturedStartTimeMs = t.startTimeMs;
      firstFeaturedName = t.name;
      firstFeaturedTrigram = t.trigram;
    }

    if (
      lastFeaturedEndTimeMs === undefined ||
      t.endTimeMs > lastFeaturedEndTimeMs
    ) {
      lastFeaturedEndTimeMs = t.endTimeMs;
      lastFeaturedName = t.name;
      lastFeaturedTrigram = t.trigram;
    }
  });

  return {
    tournamentsCount: tournamentIds.length,
    matchesCount: matchIds.length,
    firstFeaturedName,
    firstFeaturedTrigram,
    firstFeaturedStartTimeMs,
    lastFeaturedName,
    lastFeaturedTrigram,
    lastFeaturedEndTimeMs,
  };
};
